import { inject, Service } from '@angular/core';
import { CollectionServiceBase } from '@portal-core/data/collection/services/collection.service.base';
import { GetDataOptions } from '@portal-core/data/common/models/get-data-options.model';
import { WebhookChannel } from '@portal-core/slack/models/webhook-channel.model';
import { SlackWebhooksApiService } from '@portal-core/slack/services/slack-webhooks-api.service';
import { SlackWebhookChannelsDataService } from '@portal-core/slack/services/slack-webhooks-channels-data.service';
import { Resettable } from '@portal-core/util/resettable.decorator';
import { Observable, tap } from 'rxjs';

@Service()
@Resettable()
export class SlackWebhookChannelsService extends CollectionServiceBase<WebhookChannel> {
  private readonly slackWebhooksApiService = inject(SlackWebhooksApiService);

  constructor() {
    super(inject(SlackWebhookChannelsDataService));
  }

  getChannels$(licenseId: number, options: GetDataOptions = null): Observable<WebhookChannel[]> {
    return this.getDataListItems$('Licenses', licenseId, {
      fetch: () => this.slackWebhooksApiService.getChannels$(licenseId)
    }, options);
  }

  confirmAuthChannel$(licenseId: number, code: string): Observable<WebhookChannel> {
    return this.slackWebhooksApiService.confirmAuthChannel$(licenseId, code).pipe(
      tap(channel => {
        this.addItems$([channel]);
        this.addItemsToListById$('Licenses', licenseId, [channel]);
      })
    );
  }

  deleteChannel$(channelId: number): Observable<void> {
    return this.slackWebhooksApiService.deleteChannel$(channelId).pipe(
      tap(() => {
        this.deleteItems$([channelId]);
      })
    );
  }
}
